export enum AddressTypeEnum {
  preCruiseAddress = 'preCruiseAddress',
  postCruiseAddress = 'postCruiseAddress',
  residenceAddress = 'residenceAddress'
}
